// These values current sync with Bootstrap 3 Media Query Breakpoints

export const mobileBreakpoint = 320;

export const mobileLargeBreakpoint = 480;

export const tabletBreakpoint = 768;

export const desktopBreakpoint = 992;

export const desktopLargeBreakpoint = 1200;

export const breakpoints = [
	{key:'mobileBreakpoint', value: mobileBreakpoint},
	{key:'mobileLargeBreakpoint', value: mobileLargeBreakpoint},
	{key:'tabletBreakpoint', value: tabletBreakpoint},
	{key:'desktopBreakpoint', value: desktopBreakpoint},
	{key:'desktopLargeBreakpoint', value: desktopLargeBreakpoint}];
